export const PoemSunlightReflectingInPuddles = () => {
    return (
        <div id="013" className="">
            <p>every sun, that's a child,</p>
            <br />
            <p>i came into this world covered in</p>
            <p>my mother's words typewritten on my skin,</p>
            <p>so many of them she'd often</p>
            <p>lose herself in reading whenever we were talking,</p>
            <p>or rather, whenever she was talking to me.</p>
            <p>how did it go, the whole act of creation?</p>
            <p>almighty power of the word,</p>
            <p>spend seven days making the world and then you're free to </p>
            <p>worry about it and cover it in fingerprints,</p>
            <p>how much of our current form is the outcome of </p>
            <p>cupped palm-shaped words against the soft mud</p>
            <p>that is the growing body?</p>
            <p>always give to each other,</p>
            <p>always take from one another,</p>
            <p>every child is free to roam the world</p>
            <p>and make use of their own shape to act upon the environment,</p>
            <p>and take their parents' habits of</p>
            <p>making things and scribbling their words</p>
            <p>on both inanimate objects and on other people's bodies.</p>
            <p>every sun, that's a mother,</p>
            <p>our bruises and cuts, like a canvas,</p>
            <p>together, our wrinkles look like letters and whole words,</p>
            <p>there's always a source of light, for</p>
            <p>we all need to see wherever we're heading,</p>
            <p>and yes, that's how it works,</p>
            <p>first there was the need, and then came everything else.</p>
            <br />
            <p>summer days, unrepeatable,</p>
            <p>you look at me from under the shade</p>
            <p>and</p>
            <p>every moment of silence, that's a written message,</p>
            <p>haven't we </p>
            <p>finally mirrored each other</p>
            <p>when i find myself echoing the same words of worry</p>
            <p>you've said to me so many times?</p>
        </div>
    );
};
